import ToastMessage from "../toastMessage/ToastMessage";

// eslint-disable react-hooks/exhaustive-deps
var axios = require("axios");
var portalConfig = require("../config");
var toast = require("react-toastify");

const getUserToken = () => {
  const key = process.env.REACT_APP_URL;
  return JSON.parse(localStorage.getItem(`userToken_${key}`));
};

const isHandlerEnabled = (config = {}) => {
  return config.hasOwnProperty("handlerEnabled") && !config.handlerEnabled
    ? false
    : true;
};

const requestHandler = (request) => {
  // spinning start to show
  // UPDATE: Add this code to show global loading indicator
  document.body.classList.add("loading-indicator");

  if (isHandlerEnabled(request)) {
    // request.headers["Authorization"] = `Bearer ${getUserToken()}`;
    // request.headers["auth-token"] = `Bearer ${getUserToken()}`;
    request.headers["auth-token"] = getUserToken();
    // request.headers.post["Access-Control-Allow-Origin"] = "*";
  }
  return request;
};

const errorHandler = (error) => {
  // spinning hide
  // UPDATE: Add this code to hide global loading indicator
  document.body.classList.remove("loading-indicator");
  const key = process.env.REACT_APP_URL;
  if (isHandlerEnabled(error.config)) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem(`userToken_${key}`);
      window.location.reload();
      // navigate(routes?.login?.match);
    } else if (error?.response?.status === 406) {
      toast.toast.error(`${error.response.data.error}`, {
        containerId: "toast",
      });
    } else if (error?.response?.status === 403) {
      toast.toast.error(`${ToastMessage.errorList.forbidden}`, {
        containerId: "toast",
      });
    } else {
      toast.toast.error(`${error.message}`, { containerId: "toast" });
    }
  }

  return Promise.reject({ ...error });
};

const successHandler = (response) => {
  // spinning hide
  // UPDATE: Add this code to hide global loading indicator
  document.body.classList.remove("loading-indicator");

  if (isHandlerEnabled(response.config)) {
  }
  return response;
};

// Init Axios
const instance = axios.create({
  baseURL: portalConfig.APIUrl,
});

// Add interceptors
instance.interceptors.request.use((request) => requestHandler(request));

instance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

export default axios = instance;
// module.exports.axios = instance
